import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { post } from "@aws-amplify/api";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (formData.name.trim().length < 2) {
      newErrors.name = "Name must be at least 2 characters long";
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // Subject validation
    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required";
    } else if (formData.subject.trim().length < 5) {
      newErrors.subject = "Subject must be at least 5 characters long";
    }

    // Message validation
    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters long";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null); // Clear any previous status

    try {
      const response = await post({
        apiName: "numaiweb", // Replace with your API name from Amplify
        path: "/contact-us", // Replace with your API path
        options: {
          body: formData,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }).response;

      const result = await response.body.json();
      if (response.statusCode === 200) {
        setSubmitStatus({
          type: "success",
          message: "Thank you! Your message has been sent successfully.",
        });
        // Reset form
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
        setErrors({});
      } else {
        throw new Error(result.error || "Failed to send message");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitStatus({
        type: "error",
        message: error.message || "Failed to send message. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Start Contact  */}
      <section className="section" id="contact">
        <Container>
          <Row className="justify-content-center">
            <Col>
              <div className="section-title text-center mb-4 pb-2">
                <h4 className="title mb-3">Get In Touch !</h4>
                <p className="text-muted para-desc mb-0 mx-auto">
                  Expert consultants for data, business & technology.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col lg={8} md={6} className="order-md-2 order-1 mt-4 pt-2">
              <div className="p-4 rounded shadow bg-white">
                <form onSubmit={handleSubmit} method="post" name="myForm">
                  <p className="mb-0" id="error-msg"></p>
                  <div id="simple-msg"></div>

                  {/* Success/Error Message Display */}
                  {submitStatus && (
                    <div
                      className={`alert alert-${
                        submitStatus.type === "success" ? "success" : "danger"
                      } mb-4`}
                      role="alert"
                    >
                      <div className="d-flex align-items-center">
                        <i
                          className={`uil uil-${
                            submitStatus.type === "success"
                              ? "check-circle"
                              : "exclamation-triangle"
                          } me-2`}
                        ></i>
                        {submitStatus.message}
                      </div>
                    </div>
                  )}

                  <Row>
                    <Col md={6}>
                      <div className="mb-4">
                        <input
                          name="name"
                          id="name"
                          type="text"
                          className={`form-control ${
                            errors.name ? "is-invalid" : ""
                          }`}
                          placeholder="Name *"
                          value={formData.name}
                          onChange={handleChange}
                        />
                        {errors.name && (
                          <div className="invalid-feedback d-block">
                            {errors.name}
                          </div>
                        )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="mb-4">
                        <input
                          name="email"
                          id="email"
                          type="email"
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          placeholder="Email *"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="invalid-feedback d-block">
                            {errors.email}
                          </div>
                        )}
                      </div>
                    </Col>

                    <div className="col-12">
                      <div className="mb-4">
                        <input
                          name="subject"
                          id="subject"
                          className={`form-control ${
                            errors.subject ? "is-invalid" : ""
                          }`}
                          placeholder="Subject *"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                        {errors.subject && (
                          <div className="invalid-feedback d-block">
                            {errors.subject}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-4">
                        <textarea
                          name="message"
                          id="message"
                          rows={4}
                          className={`form-control ${
                            errors.message ? "is-invalid" : ""
                          }`}
                          placeholder="Message *"
                          value={formData.message}
                          onChange={handleChange}
                        ></textarea>
                        {errors.message && (
                          <div className="invalid-feedback d-block">
                            {errors.message}
                          </div>
                        )}
                      </div>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-12 text-end">
                      <button
                        type="submit"
                        id="submit"
                        name="send"
                        className="btn btn-numantra-primary"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Sending..." : "Send Message"}
                      </button>
                    </div>
                  </Row>
                </form>
              </div>
            </Col>

            <Col lg={4} md={6} className="col-12 order-md-1 order-2 mt-4 pt-2">
              <div className="me-lg-4">
                {/* <div className="d-flex">
                  <div className="icons text-center mx-auto">
                    <i className="uil uil-phone d-block rounded h4 mb-0"></i>
                  </div>

                  <div className="flex-1 ms-3">
                    <h5 className="mb-2">Phone</h5>
                    <Link to="tel:+152534-468-854" className="text-muted">
                      +152 534-468-854
                    </Link>
                  </div>
                </div> */}

                <div className="d-flex mt-4">
                  <div className="icons text-center mx-auto">
                    <i className="uil uil-envelope d-block rounded h4 mb-0"></i>
                  </div>

                  <div className="flex-1 ms-3">
                    <h5 className="mb-2">Email</h5>
                    <Link
                      to="mailto:bdm@numantratech.ai"
                      className="text-muted"
                    >
                      bdm@numantratech.ai
                    </Link>
                  </div>
                </div>

                <div className="d-flex mt-4">
                  <div className="icons text-center mx-auto">
                    <i className="uil uil-map-marker d-block rounded h4 mb-0"></i>
                  </div>

                  <div className="flex-1 ms-3">
                    <h5 className="mb-2">Our Offices</h5>
                    <div className="text-muted">
                      <div className="mb-2">
                        <strong>USA</strong>
                        <br />
                        20600 Chagrin Blvd, Shaker Heights, OH 44122
                      </div>
                      <div className="mb-2">
                        <strong>Switzerland</strong>
                        <br />
                        Bahnhofstrasse 10, 8001 Zurich
                      </div>
                      <div className="mb-2">
                        <strong>Finland</strong>
                        <br />
                        Michelininkatu 1A, 00180 Helsinki
                      </div>
                      <div className="mb-2">
                        <strong>India</strong>
                        <br />
                        301-2/510-11 Gateway Plaza, Hiranandani Gardens Powai,
                        Mumbai, MH 400076
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End Contact  */}
    </>
  );
}
